const messages = {
    en: {
        accountCreateSuccess: "Account has been created successfully",
        wrongRecaptcha: "Wrong recaptch text",
        logoutSuccess: "User has been logged out successfully",
        emailConfirmationSuccess: "Email confirmation link has been resent successfully",
        forgotPasswordSuccess: "Password reset link has been sent successfully", 
        verifyaddress: "Password reset link will be sent to the email address/username specified. Usually it takes up to 3 minutes for system to send email. Just click this link and fill password reset form",
        enterTextInBlue: "Enter text in blue below",
        newpasswordsavedsucess: "New password has been saved successfully",
        emailTaken: "This email is already taken",
        nameTaken: "This name is already taken",
        wrongEmailPassword: "Wrong email or password",
    },
    ru: {
        accountCreateSuccess: "Аккаунт успешно создан",
        wrongRecaptcha: "Неверный текст recaptcha",
        logoutSuccess: "Пользователь успешно вышел из системы",
        emailConfirmationSuccess: "Электронное письмо с подтверждением успешно отправлено повторно",
        forgotPasswordSuccess: "Ссылка для сброса пароля была успешно отправлена",
        verifyaddress: "Ссылка для сброса пароля будет отправлена ​​на указанный адрес электронной почты/имя пользователя. Обычно система отправляет электронное письмо в течение 3 минут. Просто нажмите на эту ссылку и заполните форму сброса пароля",
        enterTextInBlue: "Введите текст, выделенный синим цветом",
        newpasswordsavedsucess: "Новый пароль успешно сохранен",
        emailTaken: "Этот электронный адрес уже используется",
        nameTaken: "Это имя уже используется",
        wrongEmailPassword: "Неправильный адрес электронной почты или пароль",
    }
  };

  export default messages;